<template>
  <div class="d-flex justify-space-between align-center text-center bg-white mt-2" style="width: 100%">
    <div>
      <!-- <v-btn text color="primary" class="navigation-button" @click="subtractDay"> -->
      <v-btn variant="text" color="primary" class="navigation-button" @click="subtractDay">
        <v-icon start>mdi-chevron-left</v-icon>
        <v-badge
          color="primary"
          :content="`${beforeTheDate}`"
          v-if="beforeTheDate > 0"
          inline
        >
          前日
        </v-badge>
        <div v-else>
          前日
        </div>
      </v-btn>
    </div>
    <div>
      <div v-if="isYear" class="text-caption font-weight-bold">{{ todayYear }}</div>
      <div class="text-h6 font-weight-bold">{{ todayDate }} ({{ todayDayWeek }})</div>
    </div>
    <div>
      <v-btn variant="text" color="primary" class="navigation-button" @click="addDay">
        <v-badge
          color="primary"
          :content="`${afterTheDate}`"
          v-if="afterTheDate > 0"
          inline
        >
          翌日
        </v-badge>
        <div v-else>
          翌日
        </div>
        <v-icon end>mdi-chevron-right</v-icon>
      </v-btn>
    </div>
  </div>
</template>
<script lang="ts">
import Vue, { PropType, defineComponent } from 'vue';

import { NurseryClassResponse } from 'chaild-api/lib/index';

import LocalDataService from '@/service/LocalDataService';
import dayjs from 'dayjs';

export default defineComponent({
  components: {},
  data: () => {
    return {};
  },
  props: {
    date: {
      type: Object as PropType<any>,
      required: true,
    },
    isYear: {
      type: Boolean,
      default: true,
    },
    beforeTheDate: {
      type: Number,
      default: 0,
    },
    afterTheDate: {
      type: Number,
      default: 0,
    }
  },
  computed: {
    todayDate() {
      return this.date.format('M月D日');
    },
    todayDayWeek() {
      return this.date.format('ddd');
    },
    todayYear() {
      return this.date.format('YYYY年');
    },
  },
  methods: {
    addDay() {
      this.$emit('addDay');
    },
    subtractDay() {
      this.$emit('subtractDay');
    },
  },
  async mounted() {},
});
</script>
<style lang="scss" scoped></style>
